import { Handle, Node, NodeProps, Position } from '@xyflow/react';
import { memo } from 'react';

import { IconSvg } from '@/lib/v2/components';
import { DEFAULT_HANDLE_STYLE } from '@/lib/v3/components/Flows/CommonFlowCard';

import { SOURCE_HANDLE_NO, SOURCE_HANDLE_YES } from '@/modules/AutomationModuleNew/constants/flows';
import { ConditionIcon } from '@/modules/AutomationModuleNew/icons/flows';
import { BinaryConditionalData } from '@/modules/AutomationModuleNew/types/flowsTypes';

export type BinaryConditionalCardProps = NodeProps<Node<BinaryConditionalData>> & {
  onEdit: (nodeId: string | number) => void;
};

const BinaryConditionalCard = (props: BinaryConditionalCardProps) => {
  const { data, id: nodeId, onEdit } = props;

  if (data.type !== 'binaryConditional') return null;
  const { condition } = data.input;

  return (
    <div
      className="flex size-[45px] items-center justify-center rounded-lg border border-[#D3D3D3] bg-emblue-white p-2"
      id={nodeId}
      role="button"
      style={{ pointerEvents: 'all' }}
      tabIndex={0}
      onClick={() => onEdit(nodeId)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          return false;
        }
      }}
    >
      <Handle position={Position.Top} style={{ ...DEFAULT_HANDLE_STYLE }} type="target" />
      <IconSvg height="24px" svgComponent={<ConditionIcon />} width="24px" />
      <Handle
        id={SOURCE_HANDLE_YES}
        position={Position.Right}
        style={{ ...DEFAULT_HANDLE_STYLE }}
        type="source"
      />
      <Handle
        id={SOURCE_HANDLE_NO}
        position={Position.Left}
        style={{ ...DEFAULT_HANDLE_STYLE }}
        type="source"
      />
    </div>
  );
};

export default memo(BinaryConditionalCard);
